module.exports = __webpack_public_path__ + "static/media/homeOutline.76facfa5.svg";